export const statusMatching = (status) => {
  switch (status) {
    case 'SUBMITTED':
      return { text: 'Sending', bg: '#D0EDFD', color: '#10557C' };

    case 'REJECTED':
      return { text: 'Incomplete', bg: '#FFE6F7', color: '#A32179' };

    case 'APPROVED':
      return { text: 'Complete', bg: '#DCFCE7', color: '#174A2A' };

    case 'PENDING_APPROVAL':
      return { text: 'Waiting', bg: '#FEF3C7', color: '#F27D00' };

    case 'FAILED':
      return { text: 'Error', bg: '#FEE2E2', color: '#C71818' };

    default:
      return { text: 'N/A', bg: '#FEE2E2', color: '#C71818' };
  }
};

export const statusReverseMatching = (status) => {
  switch (status) {
    case 'Sending':
      return 'SUBMITTED';

    case 'Incomplete':
      return 'REJECTED';

    case 'Complete':
      return 'APPROVED';

    case 'Waiting':
      return 'PENDING_APPROVAL';

    case 'Error':
      return 'FAILED';

    case 'N/A':
      return 'none';

    default:
      return '';
  }
};
